import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { css } from '@emotion/react';
import { colors, shadows, typography, zIndex, getResetByTag, rem } from '../../../styles';
var bodyDefaultStyles = function bodyDefaultStyles(_ref2) {
  var isInverse = _ref2.isInverse;
  return /*#__PURE__*/css("backface-visibility:hidden;background-color:", isInverse ? colors.white : colors.navy_500, ";box-shadow:", shadows.md, ";color:", isInverse ? colors.navy_500 : colors.white, ";font-size:", typography.typographyBodySm, ";left:0;line-height:", typography.typographyLineHeightSm, ";opacity:0;padding:", rem(8, 8, 16, 16), ";perspective:1000;position:fixed;text-align:left;top:0;transition:opacity 0.2s linear,transform 0.2s ease-in-out,bottom 0.2s ease-in-out;visibility:collapse;z-index:", zIndex.zIndex_13, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bodyDefaultStyles;"));
};
var _ref = process.env.NODE_ENV === "production" ? {
  name: "10xqk2j",
  styles: "cursor:auto;opacity:1;visibility:visible"
} : {
  name: "1pkqcoo-bodyActiveStyles",
  styles: "cursor:auto;opacity:1;visibility:visible;label:bodyActiveStyles;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
var bodyActiveStyles = function bodyActiveStyles(_ref3) {
  var isActive = _ref3.isActive;
  if (isActive) {
    return _ref;
  }
};
var bodySizeStyles = function bodySizeStyles(_ref4) {
  var size = _ref4.size;
  switch (size) {
    case 'sm':
      return /*#__PURE__*/css("width:", rem(150), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bodySizeStyles;"));
    case 'md':
      return /*#__PURE__*/css("width:", rem(250), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bodySizeStyles;"));
    case 'lg':
      return /*#__PURE__*/css("width:", rem(300), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bodySizeStyles;"));
  }
};
var bodyPosition = function bodyPosition(_ref5) {
  var position = _ref5.position,
    isInverse = _ref5.isInverse;
  switch (position) {
    case 'top':
      return /*#__PURE__*/css("border-bottom:0 solid ", isInverse ? colors.white : colors.navy_500, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bodyPosition;"));
    case 'bottom':
      return /*#__PURE__*/css("border-top:0 solid ", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:bodyPosition;"));
  }
};
var resetStyles = getResetByTag('div');
var StyledTooltipBody = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "ej9jwwu0"
} : {
  target: "ej9jwwu0",
  label: "StyledTooltipBody"
})(resetStyles, bodyDefaultStyles, bodyActiveStyles, bodySizeStyles, bodyPosition);
export default StyledTooltipBody;